module.exports = __webpack_public_path__ + "static/sad_face-0f59a93c06dc99872cff7ce85b6f9b71.png";